"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRecoveryResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateRecoveryResult = (0, validation_1.properties)({
    success: (0, validation_1.bool)(),
    message: (0, validation_1.text)(),
});
//# sourceMappingURL=RecoveryResult.js.map